import { styled } from '@linaria/react'
import { COLOR, CORNERS, FIXED_INDENTS } from 'vars/index'
import { MEDIA } from 'vars/media'

export const StreamingOptionItemSC = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: var(${FIXED_INDENTS.INDENT_150});
  padding: var(${FIXED_INDENTS.INDENT_20}) var(${FIXED_INDENTS.INDENT_50});
  margin: 0;
  border: none;
  border-radius: var(${CORNERS.CORNERS_20});
  background-color: var(${COLOR.SURFACE_DARK_5});
  cursor: pointer;
  text-align: left;
  color: inherit;
  font: inherit;

  ${MEDIA.MIN_600} {
    padding: var(${FIXED_INDENTS.INDENT_20}) var(${FIXED_INDENTS.INDENT_60});
  }

  ${MEDIA.MIN_1240} {
    padding: var(${FIXED_INDENTS.INDENT_20}) var(${FIXED_INDENTS.INDENT_80});
  }

  ${MEDIA.NO_TOUCH} {
    &:hover {
      background-color: var(${COLOR.SURFACE_LIGHT_1});
    }
  }
`

export const StreamingOptionItemInnerSC = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  gap: var(${FIXED_INDENTS.INDENT_50});
  min-width: 0;

  ${MEDIA.MIN_600} {
    gap: var(${FIXED_INDENTS.INDENT_60});
  }

  ${MEDIA.MIN_1240} {
    gap: var(${FIXED_INDENTS.INDENT_80});
  }
`

export const StreamingOptionLeftSC = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  gap: var(${FIXED_INDENTS.INDENT_30});
  min-width: 0;

  ${MEDIA.MIN_600} {
    gap: var(${FIXED_INDENTS.INDENT_40});
  }
`

export const StreamingOptionLogoBoxSC = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 64px;
  height: 44px;
`

export const StreamingOptionLogoImgSC = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  pointer-events: none;
`

export const StreamingOptionTextsSC = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-width: 0;
`
